


import { defineComponent } from 'vue';

export default defineComponent({
    name: 'custom_validate',
    props:
    {

        submitted: {
            type: Boolean
        },
        vObject: {
            type: Object as any,
            default:({})
            
        },
        

    },
    setup() {
        

        return {
          

        };
    },
});
